import { Box, Typography } from "@mui/material/index.js";
import { ImportButton } from "react-admin-import-csv";
import { useTranslate, CreateButton } from "react-admin";
import PropTypes from "prop-types";

const EmptyList = (props) => {
  const { resource, isCreateAllowed } = props;
  const t = useTranslate();
  const config = {
    logging: true,
    disableImportNew: true,
    disableImportOverwrite: true,
    disableGetMany: true,
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      width="-webkit-fill-available"
      minHeight="34vh"
    >
      <svg
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 25 25"
        width="14em"
        height="14em"
        fill="#888888"
        style={{
          marginBotom: "3%",
        }}
      >
        <path d="M 19 3 H 4.99 c -1.11 0 -1.98 0.89 -1.98 2 L 3 19 c 0 1.1 0.88 2 1.99 2 H 19 c 1.1 0 2 -0.9 2 -2 V 5 c 0 -1.11 -0.9 -2 -2 -2 m 0 12 h -4 c 0 1.66 -1.35 3 -3 3 s -3 -1.34 -3 -3 H 4.99 V 5 H 19 Z"></path>
      </svg>
      <Typography
        variant="h4"
        sx={{
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          fontWeight: "400",
          fontSize: "2.125rem",
          lineHeight: "1.235",
          letterSpacing: "0.00735em",
          color: "#888888",
        }}
        paragraph
      >
        {t("resources.notifications.no_available", {
          resource: t(`resources.${resource}.name`),
        })}
      </Typography>
      {isCreateAllowed === true && (
        <>
          <Typography
            sx={{
              fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
              fontWeight: "400",
              fontSize: "1rem",
              lineHeight: "1.5",
              letterSpacing: "0.00938em",
              marginBottom: "5%",
              color: "#888888",
            }}
            variant="body1"
          >
            {t("resources.Coupon.source.import_file")}
          </Typography>
          {resource === "Coupon" || resource === "Coordinate" ? (
            <ImportButton
              sx={{ color: "#291680", fontSize: "0.855rem" }}
              {...props}
              {...config}
              parseConfig={{ dynamicTyping: true }}
            />
          ) : (
            <CreateButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
          )}
        </>
      )}
    </Box>
  );
};

EmptyList.propTypes = {
  resource: PropTypes.string,
  isCreateAllowed: PropTypes.bool,
};

export default EmptyList;
